import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  footer: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(7.5, 15),
    overflow: 'hidden',
    '& .container': {
      [theme.breakpoints.up('lg')]: {
        width: 1140,
        margin: '0 auto',
      },
    },
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(7, 10),
    },
    '& h5': {
      textTransform: 'uppercase',
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(5, 4),
      '& h5': {
        fontSize: '17px!important',
        fontWeight: '700!important',
        textTransform: 'none',
        '& svg': {
          color: theme.palette.primary.contrastText,
          float: 'right',
          fontSize: 34,
        },
      },
    },
  },
  columnList: {
    listStyleType: 'none',
    padding: 0,
    '& li': {
      marginBottom: theme.spacing(0.75),
    },
    '& a': {
      color: theme.palette.primary.contrastText,
      fontSize: 14,
      textDecoration: 'none',
      '&:hover': {
        color: theme.custom.footerLinkHover,
      },
      '&#ot-sdk-btn.ot-sdk-show-settings': {
        color: theme.palette.primary.contrastText,
        fontSize: 14,
        border: 'none',
        padding: 0,
        '&:hover': {
          color: theme.custom.footerLinkHover,
          background: 'none',
        },
      },
    },
  },
  moto: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    paddingBottom: theme.spacing(3),
    '& span': {
      width: 537,
      padding: '0 0 20px',
      fontSize: '1.75rem',
      fontWeight: 300,
      display: 'inline-block',
      color: theme.palette.primary.contrastText,
      borderBottom: '1px solid #fff',
      [theme.breakpoints.down('md')]: {
        width: 320,
      },
    },
  },
}));
